<script setup>
import {toRefs, computed} from 'vue'

//Props
const props = defineProps({
  error: {
    type: [Error, Object, String],
    default: '',
  },
  isBlock: {
    type: Boolean,
    default: false,
  },
})

//Determine error message
const {error} = toRefs(props)
const message = computed(() => {
  if (error.value instanceof Error) {
    return error.value.message
  }
  else if (typeof error.value === 'object') {
    return error.value.message || error.value.$message || ''
  }
  return error.value
})

//Normalized message
const normalizedMessage = computed(() => {
  if (message.value === 'Request failed with status code 500') {
    return 'An unexpected server error occurred'
  }
  else if (message.value === 'Request failed with status code 401') {
    return 'You are not authorized to perform this action'
  }
  return message.value
})
</script>

<template>
  <component
    :is="isBlock ? 'p' : 'span'"
    text-danger
  >
    {{ normalizedMessage }}
  </component>
</template>
